export default "__VITE_ASSET__4af8ef78__"